// Helpers for KIN-1216: turn the unified clinical-data envelope (KIN-1215,
// PatientClinicalDataDto) into flat { feKey: value } maps ready to merge into a
// review draft. Each source field is an { value, observedAt } pair; a null
// value means "not on record" and is skipped so the FE never fills a sentinel.

// Vitals key deliberately NOT prefilled: weight must be re-measured every visit
// (height/waist are stable and do carry forward). See ReviewAndExamForm.
const VITALS_PREFILL_EXCLUDED = new Set(["weight"]);

// FE keys that live in cdmMatrix and are therefore gated per condition × review.
// Diagnostics / lifestyle / vitals are rendered on fixed steps and are not
// matrix-keyed, so they are never gated here.
export const CLINICAL_BLOODS_KEYS = [
  "haemoglobin",
  "totalCholesterol",
  "hdlCholesterol",
  "ldlCholesterol",
  "triglycerides",
  "hba1c",
  "fastingGlucose",
  "serumCreatinine",
  "egfr",
  "acr",
  "ntProBNP",
];

// { key: { value, observedAt } } -> { key: String(value) } for non-null values,
// optionally dropping excluded keys.
const flattenObsGroup = (group, excluded) => {
  if (!group) return {};

  return Object.entries(group).reduce((accumulator, [key, observation]) => {
    if (excluded?.has(key)) return accumulator;

    const value = observation?.value;
    if (value !== null && value !== undefined && value !== "") {
      accumulator[key] = String(value);
    }

    return accumulator;
  }, {});
};

// Returns the prefillable values grouped so each caller can apply its own
// visibility guards (bloods are matrix-gated; the rest are always rendered).
export const buildClinicalPrefill = (clinicalData) => ({
  bloods: flattenObsGroup(clinicalData?.bloods),
  vitals: flattenObsGroup(clinicalData?.vitals, VITALS_PREFILL_EXCLUDED),
  diagnostics: flattenObsGroup(clinicalData?.diagnostics),
  lifestyle: flattenObsGroup(clinicalData?.lifestyle),
});
